import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TitleContainer = styled.div.withConfig({
  displayName: "ExecutionResultsError__TitleContainer",
  componentId: "sc-1arahr9-0"
})(["padding-top:10px;padding-bottom:10px;"]);
const ExecutionResultsError = () => /*#__PURE__*/_jsx(TitleContainer, {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-log-events.logEventExecutionResultsTable.loadingError"
  })
});
export default ExecutionResultsError;